import { render } from "./HeaderGeneric.vue?vue&type=template&id=010d3678&scoped=true&ts=true"
import script from "./HeaderGeneric.vue?vue&type=script&lang=ts"
export * from "./HeaderGeneric.vue?vue&type=script&lang=ts"

import "./HeaderGeneric.vue?vue&type=style&index=0&id=010d3678&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010d3678"],['__file',"src/components/header/HeaderGeneric.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "010d3678"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('010d3678', __exports__)) {
    api.reload('010d3678', __exports__)
  }
  
  module.hot.accept("./HeaderGeneric.vue?vue&type=template&id=010d3678&scoped=true&ts=true", () => {
    api.rerender('010d3678', render)
  })

}


export default __exports__